"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});

var react_1 = require("react");

var SUBMIT_OFF = false;
var SUBMIT_ON = true;

var existErrorInDataForm = function existErrorInDataForm(data) {
  var fieldWithError = Object.entries(data).find(function (_a) {
    var field = _a[1];
    return !!field.error;
  });
  return !fieldWithError;
};

var dataFormat = function dataFormat(data) {
  var dataFields = {};
  var objectEntries = Object.entries(data);

  for (var i = 0; i < objectEntries.length; i++) {
    var _a = objectEntries[i],
        key = _a[0],
        value = _a[1];
    dataFields[key] = value.value;
  }

  return dataFields;
};

var useForm = function useForm() {
  var _a = react_1.useState(SUBMIT_OFF),
      isSubmit = _a[0],
      setSubmit = _a[1];

  var _isValid = react_1.useRef();

  var dataFormFields = react_1.useRef({});
  return {
    isSubmit: isSubmit,
    isValid: function isValid() {
      return _isValid.current;
    },
    setFields: function setFields(dataForm) {
      _isValid.current = existErrorInDataForm(dataForm);
      dataFormFields.current = dataForm;
    },
    handleSubmit: function handleSubmit(onSubmit) {
      return function () {
        setSubmit(SUBMIT_ON);
        onSubmit({
          data: dataFormat(dataFormFields.current),
          formIsValid: _isValid.current
        });
      };
    }
  };
};

exports.default = useForm;